import { ContentPasteSearchRounded, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Badge, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useAppSelector } from 'app/config/store';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface IMaintenance {
  setOpen: (value: boolean) => void;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  drawerIsOpen: boolean;
}

export const InspectionMenu = (props: IMaintenance) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  const delayedInspectionsCount = useAppSelector(state => state.inspectionHistory.countAlt);

  return (
    <>
      <Tooltip title={props.drawerIsOpen ? '' : <Translate contentKey="global.menu.entities.inspection">Inspection</Translate>} placement="right">
        <ListItemButton
          onClick={() => props.onExpand(props.index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: props.isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <Badge badgeContent={!props.isExpanded && delayedInspectionsCount ? delayedInspectionsCount : 0} color="error" variant="dot">
              <ContentPasteSearchRounded />
            </Badge>
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.entities.inspection">Inspeção</Translate>}
            primaryTypographyProps={{
              fontWeight: props.isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {props.isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={props.isExpanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding onClick={() => props.setOpen(false)}>
          <MenuItem icon="asterisk" to="/inspection-delayed">
            <Badge
              badgeContent={props.isExpanded && delayedInspectionsCount ? delayedInspectionsCount : 0}
              color="error"
              max={999}
              style={{ transform: 'translate(150px, -10px)' }}
            />
            <Translate contentKey="global.menu.entities.inspectionDelayed" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/inspection-item">
            <Translate contentKey="global.menu.entities.inspectionItem" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/inspection">
            <Translate contentKey="global.menu.entities.inspectionList" />
          </MenuItem>
          <MenuItem icon="asterisk" to="/inspection-history">
            <Translate contentKey="global.menu.entities.inspectionHistory" />
          </MenuItem>
        </List>
      </Collapse>
    </>
  );
};
